export enum ERSIcon {

    // fab - brands
    Github = "github",
    CuttleFish = 'cuttle-fish',
    CSS = 'css',
    HTML = 'html',
    JsSquare = 'javascript-square',
    Python = 'python',
    RaspberryPi = 'raspberry-pi',
    Twitter = 'twitter',
    TypeScript = "",
    Twitch = 'twitch',
    Instagram = 'instagram',
    Facebook = 'facebook',
    Youtube = 'youtube',
    LinkedIn = 'linkedin',
    Unity = 'unity',
    MongoDB = 'leaf',
    OpenSCAD = 'file-code',
    React = 'react',
    Discord = 'discord',
    Spotify = 'spotify', 
    

    // fas - solid
    FileCode = 'file-code',
    LightBulb = 'light-bulb',
    Bolt = 'bolt',


    EllipsisH = "ellipsis-h",
    Play = "play",
    Fire = "fire",
    Database = "database",
    Robot = "robot",
    Other = "other",
    QuestionCircle = 'question-circle',
    Link = 'link',

    Seedling = "seedling",

    
    
}
